export class DiagnosisGeneralResult {
  constructor(public id?,
              public vehiclePlate?,
              public diagnosisDate?,
              public equipmentDiagnosisResult?,
              public gpsDiagnosisResult?,
              public gprsDiagnosisResult?,
              public coordinatesDiagnosisResult?,
              public argosUser?,
              public isCan?,
              public approved?,
              public monitoring?,
              public coordinates?,
              public trixUserId?,
              public vehicleId?) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/diagnosis-general-result.ts